import script from "./MrrWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./MrrWidget.vue?vue&type=script&setup=true&lang=js"

import "./MrrWidget.vue?vue&type=style&index=0&id=52a9e99c&lang=css"

const __exports__ = script;

export default __exports__